<!-- Modal -->
<form class="form-horizontal" [formGroup]="form" novalidate (ngSubmit)="form.valid && confirm()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Información de Referencia</h5>
        <div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Primer Nombre</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="firstName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="firstName" [ngClass]="form.controls.firstName.errors ? 'is-invalid' : 'is-valid'">
            </div>
          </div>
          <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Segundo Nombre</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="middleName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="middleName">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Primer Apellido</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="lastName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="lastName" [ngClass]="form.controls.lastName.errors ? 'is-invalid' : 'is-valid'">
            </div>
          </div>
          <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Segundo Apellido</b>
              <span appRequiredAsterisk [formGroup]="form" controlName="secondLastName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="secondLastName">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Parentesco </b>
              <span appRequiredAsterisk [formGroup]="form" controlName="familyRelationship"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <ng-select formControlName="familyRelationship" [items]="familyRelationships" bindLabel="value" bindValue="key"></ng-select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Celular </b>
              <span appRequiredAsterisk [formGroup]="form" controlName="mobilePhone"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" [mask]="'0000-0000'" [showMaskTyped]="true" formControlName="mobilePhone" [ngClass]="form.controls.mobilePhone.errors ? 'is-invalid' : 'is-valid'">
            </div>
          </div>
          <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Teléfono </b>
              <span appRequiredAsterisk [formGroup]="form" controlName="phone"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" [mask]="'0000-0000'" [showMaskTyped]="true" formControlName="phone">
            </div>
          </div>
          <div class="row" *ngIf="!isShortFormActiveForPlan">
            <div class="form-group col-md-8">
              <label class="col-form-label"><b>Teléfono Trabajo</b>
                <span appRequiredAsterisk [formGroup]="form" controlName="workPhone"></span>
              </label>
              <input type="text" class="form-control" formControlName="workPhone" [mask]="'0000-0000'" [showMaskTyped]="true">
            </div>
            <div class="form-group col-md-4">
              <label class="col-form-label"><b>Extensión</b>
                <span appRequiredAsterisk [formGroup]="form" controlName="workPhoneExtension"></span>
              </label>
              <input type="text" class="form-control" formControlName="workPhoneExtension">
            </div>
          </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancelar</button>
            <button type="button" class="btn btn-outline-primary" (click)="draft()"><i class="fa fa-plus"></i>&nbsp;Borradores</button>
            <button type="submit" class="btn btn-outline-success">Confirmar</button>
        </div>
    </div>
    </form>
    